var bluemoon;
(function (bluemoon) {
    var analytics;
    (function (analytics) {
        'use strict';
        angular.module('bluemoon.analytics', ['angulartics']);
    })(analytics = bluemoon.analytics || (bluemoon.analytics = {}));
})(bluemoon || (bluemoon = {}));
//# sourceMappingURL=bluemoon-analytics-module.js.map;var bluemoon;
(function (bluemoon) {
    var analytics;
    (function (analytics) {
        'use strict';
        var BluemoonAnalyticsProvider = /** @class */ (function () {
            BluemoonAnalyticsProvider.$inject = ["$analyticsProvider"];
            function BluemoonAnalyticsProvider($analyticsProvider) {
                var _this = this;
                this.$analyticsProvider = $analyticsProvider;
                this.sendAnalyticsToProd = function (newValue, callback) {
                    _this.isDataGoingToProd = newValue;
                    var configObj = {
                        'version': '0.2.1',
                        'adapters': [
                            {
                                'type': 'Http',
                                'config': {
                                    'url': 'https://collector-product-insight.thomsonreuters.com/v1/data',
                                    'flush_period': 60000,
                                    'headers': {
                                        'X-PRODUCT-INSIGHTS-TOKEN': 'd6PkzZ2pIRi3dANyr7IWORQcEww1qnSW'
                                    }
                                }
                            }
                        ]
                    };
                    if (!_this.isDataGoingToProd) {
                        //dev-bluemoon-client Product Insight Project ID
                        configObj
                            .adapters[0]
                            .config
                            .headers['X-PRODUCT-INSIGHTS-TOKEN'] = 'd6PkzZ2pIRi3dANyr7IWORQcEww1qnSW';
                    }
                    else {
                        //bluemoon-client Product Insight Project ID
                        configObj
                            .adapters[0]
                            .config
                            .headers['X-PRODUCT-INSIGHTS-TOKEN'] = 'vIVU3MIibpvd7DRjQGpdhSrRypYC66K1';
                    }
                    //Set the global object for the TRAAC JavaScript Library Config
                    window.TRAAC_CONFIG = configObj;
                    if (typeof callback === 'function' && callback) {
                        callback();
                    }
                };
                this.loadTRAACLibrary = function (callback) {
                    if (!window.TRAAC_CONFIG) {
                        console.error('Missing TRAAC config');
                    }
                    window.TRAAC = {
                        track: function (event) {
                            window.TRAAC_CONFIG.teq.push(event);
                        },
                        registerOnce: function (kvp) {
                            window.TRAAC_CONFIG.teq.push({
                                'method': 'registerOnce',
                                'p1': kvp
                            });
                        },
                        register: function (kvp) {
                            window.TRAAC_CONFIG.teq.push({
                                'method': 'register',
                                'p1': kvp
                            });
                        },
                        setUser: function (uid) {
                            window.TRAAC_CONFIG.teq.push({
                                'method': 'setUser',
                                'p1': uid
                            });
                        },
                        clearUser: function () {
                            window.TRAAC_CONFIG.teq.push({
                                'method': 'clearUser'
                            });
                        },
                        deRegister: function (key) {
                            window.TRAAC_CONFIG.teq.push({
                                'method': 'deRegister',
                                'p1': key
                            });
                        },
                        flush: function (callback, timeout) {
                            window.TRAAC_CONFIG.teq.push({
                                'method': 'flush',
                                'p1': callback,
                                'p2': timeout
                            });
                        }
                    };
                    window.TRAAC_CONFIG.teq = [];
                    if (typeof callback === 'function' && callback) {
                        callback();
                    }
                };
                // information on analytics providers here - https://github.com/angulartics/angulartics
                this.configAngulartics = function (excludeHTMLRoutes) {
                    _this.$analyticsProvider.registerSetUsername(function (userId) {
                        window.TRAAC.setUser(userId);
                    });
                    _this.$analyticsProvider.registerSetSuperPropertiesOnce(function (properties) {
                        window.TRAAC.registerOnce(properties);
                    });
                    _this.$analyticsProvider.registerSetSuperProperties(function (properties) {
                        window.TRAAC.register(properties);
                    });
                    _this.$analyticsProvider.registerPageTrack(function (path, extraInfo) {
                        window.TRAAC.track(function () {
                            var metaD = _this.breakupURL(path);
                            var event = window.TRAAC.keyValue('Page View', metaD);
                            return event.build();
                        });
                    });
                    _this.$analyticsProvider.registerEventTrack(function (action, properties) {
                        window.TRAAC.track(function () {
                            var event = window.TRAAC.keyValue(action, properties);
                            // exclude .html url routes
                            var excludingHTML = (typeof excludeHTMLRoutes !== 'undefined') && excludeHTMLRoutes === true;
                            if (excludingHTML && properties && properties.url && properties.url.endsWith('.html') === true) {
                                return;
                            }
                            return event.build();
                        });
                    });
                };
                this.breakupURL = function (path) {
                    var tempParts = [];
                    var urlParts = path.split('/');
                    var urlData = {
                        page: '',
                        additionalPath: [],
                        urlParams: []
                    };
                    if (urlParts[0] === '' && urlParts[1] === '') {
                        urlData.page = '/';
                    }
                    else {
                        for (var i = 1; i < urlParts.length; i++) {
                            if (urlParts[i].indexOf('?') === -1) {
                                if (i === 1) {
                                    urlData.page = urlParts[i];
                                }
                                else {
                                    urlData.additionalPath.push(urlParts[i]);
                                }
                            }
                            else {
                                if (i === 1) {
                                    tempParts = urlParts[i].split('?');
                                    if (typeof tempParts[0] !== 'undefined') {
                                        urlData.page = tempParts[0];
                                    }
                                    if (typeof tempParts[1] !== 'undefined') {
                                        urlData.urlParams = tempParts[1].split('&');
                                    }
                                }
                                else {
                                    tempParts = urlParts[i].split('?');
                                    if (typeof tempParts[0] !== 'undefined') {
                                        urlData.additionalPath.push(tempParts[0]);
                                    }
                                    if (typeof tempParts[1] !== 'undefined') {
                                        urlData.urlParams = tempParts[1].split('&');
                                    }
                                }
                            }
                        }
                        urlData.additionalPath = urlData.additionalPath.join('/');
                    }
                    return urlData;
                };
                this.isDataGoingToProd = false;
            }
            BluemoonAnalyticsProvider.prototype.$get = function () {
                return {};
            };
            return BluemoonAnalyticsProvider;
        }());
        angular.module('bluemoon.analytics')
            .provider('bluemoonAnalytics', BluemoonAnalyticsProvider);
    })(analytics = bluemoon.analytics || (bluemoon.analytics = {}));
})(bluemoon || (bluemoon = {}));
//# sourceMappingURL=bluemoonAnalyticsProvider.js.map